module.exports = __webpack_public_path__ + "static/media/webapp_bck.40853596.png";